import React from "react";
import { fechaES } from "../utils";

const ESTADOS = [
  ["", "Todos", "Todos los alumnos"],
  ["con_cita", "Con fecha", "Tienen cita de check-in"],
  ["sin_cita", "Sin fecha", "No tienen cita de check-in"],
  ["fuera_de_hora", "Fuera de hora", "Han indicado que llegan fuera de hora"],
  ["sin_fecha", "Sin nada", "Ni cita ni fuera de hora"],
];
const LLEGADA = [
  ["", "Todos", "Todos"],
  ["si", "Han llegado", "Ya marcados como llegados"],
  ["no", "Pendientes", "Todavía no han llegado"],
];

const ACCESO = [
  ["", "Todos", "Todos los alumnos"],
  ["han_entrado", "Han entrado", "Han entrado a la app al menos una vez"],
  ["nunca", "Sin entrar todavía", "No han entrado nunca a la app"],
];

// Selector de opciones en píldoras (más rápido que un desplegable cuando hay pocas opciones).
export function Seg({ valor, opciones, onCambio, etiqueta }) {
  return (
    <div className="ci-seg" role="radiogroup" aria-label={etiqueta}>
      {opciones.map(([v, t, ayuda]) => (
        <button key={v} type="button" role="radio" aria-checked={valor === v} title={ayuda}
                className={valor === v ? "on" : ""} onClick={() => onCambio(v)}>{t}</button>
      ))}
    </div>
  );
}

// Barra de filtros común. `campos` decide cuáles se enseñan:
//   q piso servicio a_r empresa estado fecha franja llegado
// `opciones` = lo que devuelve /<area>/opciones. Los botones van como children.
export default function FiltrosAlumnos({ f, setF, opciones = {}, campos, children }) {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const poner = (k) => (v) => setF({ ...f, [k]: v });
  const tiene = (k) => campos.includes(k);
  const activo = (k) => (f[k] ? "activo" : "");
  const nActivos = Object.entries(f).filter(([, v]) => v !== "" && v != null).length;

  return (
    <div className="ci-filtros">
      <div className="ci-filtros-cab">
        <span className="ci-filtros-tit">🔎 Filtros</span>
        {nActivos > 0 && <span className="ci-filtros-n">{nActivos} activo{nActivos === 1 ? "" : "s"}</span>}
        <div className="ci-acciones">
          <button className="btn btn-mini" onClick={() => setF({})} disabled={nActivos === 0}>✕ Limpiar filtros</button>
          {children}
        </div>
      </div>

      {(tiene("estado") || tiene("llegado") || tiene("acceso")) && (
        <div className="ci-filtros-rapidos">
          {tiene("estado") && (
            <div className="ci-rapido"><span className="ci-etiqueta">Fecha de check-in</span>
              <Seg etiqueta="Fecha de check-in" valor={f.estado || ""} opciones={ESTADOS} onCambio={poner("estado")} /></div>
          )}
          {tiene("acceso") && (
            <div className="ci-rapido"><span className="ci-etiqueta">Ha entrado a la app</span>
              <Seg etiqueta="Ha entrado a la app" valor={f.acceso || ""} opciones={ACCESO} onCambio={poner("acceso")} /></div>
          )}
          {tiene("llegado") && (
            <div className="ci-rapido"><span className="ci-etiqueta">Llegada</span>
              <Seg etiqueta="Llegada" valor={f.llegado || ""} opciones={LLEGADA} onCambio={poner("llegado")} /></div>
          )}
        </div>
      )}

      <div className="ci-filtros-campos">
        {tiene("q") && (
          <div className={`field ancho buscador ${activo("q")}`}>
            <label>Buscar</label>
            <input value={f.q || ""} onChange={set("q")} placeholder="Nombre, correo o ID cliente…" />
          </div>
        )}
        {tiene("piso") && (
          <div className={`field ${activo("piso")}`}>
            <label>Piso (código)</label>
            <input value={f.piso || ""} onChange={set("piso")} placeholder="Ej.: AB12" />
          </div>
        )}
        {tiene("servicio") && (
          <div className={`field ${activo("servicio")}`}>
            <label>SERV</label>
            <select value={f.servicio || ""} onChange={set("servicio")}>
              <option value="">Todos</option>
              {(opciones.servicios || []).map((v) => <option key={v}>{v}</option>)}
            </select>
          </div>
        )}
        {tiene("a_r") && (
          <div className={`field ${activo("a_r")}`}>
            <label>Admisiones/R</label>
            <select value={f.a_r || ""} onChange={set("a_r")}>
              <option value="">Todos</option>
              {(opciones.a_r || []).map((v) => <option key={v}>{v}</option>)}
            </select>
          </div>
        )}
        {tiene("empresa") && (
          <div className={`field ${activo("empresa")}`}>
            <label>Empresa</label>
            <select value={f.empresa || ""} onChange={set("empresa")}>
              <option value="">Todas</option>
              {(opciones.empresas || []).map((v) => <option key={v}>{v}</option>)}
            </select>
          </div>
        )}
        {tiene("fecha") && (
          <div className={`field ${activo("fecha")}`}>
            <label>Día de la cita</label>
            <input type="date" value={f.fecha || ""} onChange={set("fecha")} />
          </div>
        )}
        {tiene("franja") && (
          <div className={`field ${activo("id_franja")}`}>
            <label>Franja</label>
            <select value={f.id_franja || ""} onChange={(e) => setF({ ...f, id_franja: e.target.value })}>
              <option value="">Todas</option>
              {(opciones.franjas || []).map((x) => (
                <option key={x.id} value={x.id}>{fechaES(x.fecha).slice(0, 5)} · {x.hora_inicio}</option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
}
